export default [
  {
    path: '/dashboard/analytics',
    name: 'dashboard-analytics',
    component: () => import('@/views/dashboard/analytics/Analytics.vue'),
  },
  // {
  //   path: '/dashboard/ecommerce',
  //   name: 'dashboard-ecommerce',
  //   component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
  // },
  {
    path: '/dashboard',
    name: 'dashboard-ecommerce',
    component: () => import('@/views/dashboard/Dashboard.vue'),
  },
  {
    path: '/dashboard-bangkok',
    name: 'dashboard-bangkok',
    component: () => import('@/views/dashboard-bangkok/Dashboard.vue'),
  },
  {
    path: '/dashboard-statistic-fasttrack',
    name: 'dashboard-statistic-fasttrack',
    component: () => import('@/views/dashboard-fasttrack/DashboardFasttrack.vue'),
  },
  // {
  //   path: '/dashboard/fasttrack',
  //   name: 'dashboard-fasttrack',
  //   component: () => import('@/views/dashboard-fasttrack/Dashboard.vue'),
  // },
  {
    path: '/dashboard-fasttrack-role',
    name: 'DashboardStatisticsFasttrackRole',
    component: () => import('@/views/dashboard-fasttrack-role/Dashboard.vue'),
  },
  {
    path: '/dashboard-fasttrack-role-screening', // คัดกรอง
    name: 'dashboard-fasttrack-role-screening',
    component: () => import('@/views/dashboard-fasttrack-role/DashboardScreening.vue'),
  },
  {
    path: '/dashboard-fasttrack-role-admin', // ธรุการ
    name: 'dashboard-fasttrack-role-admin',
    component: () => import('@/views/dashboard-fasttrack-role/DashboardDivisionAdministration.vue'),
  },
  {
    path: '/dashboard-fasttrack-role-officer', // เจ้าหน้าที่
    name: 'dashboard-fasttrack-role-officer',
    component: () => import('@/views/dashboard-fasttrack-role/DashboardDivisionOffier.vue'),
  },
]
